import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"]

  activate(event) {
    this.linkTargets.forEach((link) => {
      link.dataset.active = link === event.currentTarget
    })
  }
}
